export default (licenses) => {
    if (licenses && licenses.length > 0) {
      if (licenses[0].approved) {
        return new Date(licenses[0].startDate).getFullYear() + '-' + licenses[0].competitorId.toString().padStart(4, '0');
      }
    }
    return 'Nema licencu';
}